import {makeElement} from "../../../utils/utils";
import {linksToSpa} from "../../../utils/htmlStuff";

export default class Ph_PostLink extends HTMLElement {
	constructor(url: string, thumbnailUrl: string) {
		super();

		this.classList.add("linkPreviewWrapper");

		if (thumbnailUrl && /^https?:\/\//.test(thumbnailUrl))
			this.append(
				makeElement("a", {
					class: "link", href: url, rel: "noopener" }, [makeElement("img", { src: thumbnailUrl, alt: "preview" })])
			);

		let anchor = makeElement(
			"a", { href: url, rel: "noopener" }, url);

		anchor.innerText = anchor["host"];

		this.append(anchor);
			
		linksToSpa(this);
	}
}

customElements.define('ph-post-link', Ph_PostLink);
